module.exports = __webpack_public_path__ + "img/tyre-icon.102a2242.svg";